import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right-1",
  "use": "arrow-right-1-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right-1\">\n<path d=\"M10 6.49998C10 6.62785 9.95113 6.75585 9.8535 6.85348L4.85353 11.8535C4.65815 12.0488 4.34178 12.0488 4.14653 11.8535C3.95128 11.6581 3.95116 11.3417 4.14653 11.1465L8.79301 6.49998L4.14653 1.85348C3.95116 1.65811 3.95116 1.34173 4.14653 1.14648C4.3419 0.951235 4.65828 0.95111 4.85353 1.14648L9.8535 6.14648C9.95113 6.2441 10 6.3721 10 6.49998Z\" fill=\"#202022\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol